import { ActionType, getType } from 'typesafe-actions'

import * as actions from './actions'
import { IDrugsState, createInitialDrugsState } from './types'
import { IDrug } from '../../types/drug'
import { IEntityHashMap } from 'flux-entities'

type TAction = ActionType<typeof actions>

const initialDrugsState = createInitialDrugsState()

const drugsReducer = (state = initialDrugsState, action: TAction): IDrugsState => {
  switch (action.type) {
    case getType(actions.drugsError): {
      return {
        ...state,
        errors: action.payload,
        touched: true,
        loading: false,
      }
    }

    case getType(actions.drugsRequest): {
      return {
        ...state,
        touched: true,
        loading: true,
      }
    }

    case getType(actions.drugsSuccess): {
      const all: IEntityHashMap<IDrug> = {}
      const ids: number[] = []

      for (const drug of action.payload) {
        if (!all[drug.id]) {
          ids.push(drug.id)
          all[drug.id] = drug
        }
      }

      return {
        all,
        ids,
        touched: true,
        loading: false,
        errors: []
      }
    }
  }

  return state
}

export {
  drugsReducer,
  initialDrugsState
}
